import { GeoLocationByIpAddress, GeoLocationByPlace } from "../types/GeoLocation";
import { AirQualityIndex, DegreeType, Weather, WeatherAlert } from "../types/Weather";

export const getGeoLocationByPlace = async (searchTerm: string | null, baseUrl: string | undefined): Promise<GeoLocationByPlace[]> => {
  if (!searchTerm || !baseUrl) {
    return [];
  }

  const response = await fetch(`${baseUrl}/v1/search?name=${searchTerm}&count=10&language=en&format=json`);
  const data = await response.json();
  const geoLocations: GeoLocationByPlace[] = data.results;

  return geoLocations;
};


export const getWeather = async (lat: number | undefined, long: number | undefined, degreeType: DegreeType, baseUrl: string | undefined): Promise<Weather | null> => {
  if (!lat || !long || !baseUrl) {
    return null;
  }

  const useFehrenheitArg = degreeType === 'fahrenheit' ? '&temperature_unit=fahrenheit' : '';

  const response = await fetch(`${baseUrl}/v1/forecast?latitude=${lat}&longitude=${long}&current_weather=true` +
    `&hourly=temperature_2m,relativehumidity_2m,apparent_temperature,precipitation_probability,rain,showers,snowfall,weathercode,visibility,is_day` +
    `&daily=weathercode,temperature_2m_max,temperature_2m_min,uv_index_max,precipitation_probability_mean,sunrise,sunset` +
    `&models=ecmwf_ifs04,gfs_global&timezone=auto` +
    useFehrenheitArg);
  const weather: Weather = await response.json();

  return weather;
}

export const getGeoLocationByIpAddress = async (baseUrl: string | undefined): Promise<GeoLocationByIpAddress> => {

  const response = await fetch(`${baseUrl}/json`);
  const geoLocation: GeoLocationByIpAddress = await response.json();

  return geoLocation;
};

export const getWeatherAlertsByCity = async (city: string, country: string, baseUrl: string): Promise<WeatherAlert[]> => {
  const encodedUrl = encodeURI(`${baseUrl}?city=${city}&country=${country}`);

  const response = await fetch(encodedUrl);
  const weatherAlerts = await response.json();

  return weatherAlerts;
};

export const getAirQualityIndex = async (lat: number | undefined, long: number | undefined, baseUrl: string | undefined): Promise<AirQualityIndex | null> => {
  if (!lat || !long || !baseUrl) {
    return null;
  }

  const response = await fetch(`${baseUrl}/v1/air-quality?latitude=${lat}&longitude=${long}` +
    `&hourly=us_aqi&timezone=auto`);
  const aqi = await response.json();

  return aqi;
}